export default "__VITE_ASSET__54b2ee25__"